'use strict';

class generalLedgerService {
  constructor($http) {
    this.$http = $http;
  }

  get() {
    return this.$http.get(`/generalledger/settings`);
  }

  save(params) {
    return this.$http.post(`/generalledger/settings`, params);
  }
}

generalLedgerService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('generalLedgerService', generalLedgerService);
